/* tslint:disable */
import {
  Player,
  Screen,
  KanvasUser,
  CategoryRotation,
  ScheduleTimeframe
} from '../index';

declare var Object: any;
export interface PlayerGroupInterface {
  "id": string;
  "name": string;
  "isOverrideGroup"?: boolean;
  "isSinglePlayerGroup"?: boolean;
  "kanvasUserId"?: string;
  "parentContributorId"?: string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
  "categoryRotationId"?: string;
  players?: Player[];
  overridePlayers?: Player[];
  screens?: Screen[];
  kanvasUser?: KanvasUser;
  parentContributor?: KanvasUser;
  categoryRotation?: CategoryRotation;
  scheduleTimeframes?: ScheduleTimeframe[];
}

export class PlayerGroup implements PlayerGroupInterface {
  "id": string;
  "name": string;
  "isOverrideGroup": boolean;
  "isSinglePlayerGroup": boolean;
  "kanvasUserId": string;
  "parentContributorId": string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
  "categoryRotationId": string;
  players: Player[];
  overridePlayers: Player[];
  screens: Screen[];
  kanvasUser: KanvasUser;
  parentContributor: KanvasUser;
  categoryRotation: CategoryRotation;
  scheduleTimeframes: ScheduleTimeframe[];
  constructor(data?: PlayerGroupInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PlayerGroup`.
   */
  public static getModelName() {
    return "PlayerGroup";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PlayerGroup for dynamic purposes.
  **/
  public static factory(data: PlayerGroupInterface): PlayerGroup{
    return new PlayerGroup(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PlayerGroup',
      plural: 'PlayerGroups',
      path: 'PlayerGroups',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'string'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "isOverrideGroup": {
          name: 'isOverrideGroup',
          type: 'boolean'
        },
        "isSinglePlayerGroup": {
          name: 'isSinglePlayerGroup',
          type: 'boolean'
        },
        "kanvasUserId": {
          name: 'kanvasUserId',
          type: 'string'
        },
        "parentContributorId": {
          name: 'parentContributorId',
          type: 'string'
        },
        "createdByIp": {
          name: 'createdByIp',
          type: 'string'
        },
        "lastUpdatedByIp": {
          name: 'lastUpdatedByIp',
          type: 'string'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "categoryRotationId": {
          name: 'categoryRotationId',
          type: 'string'
        },
      },
      relations: {
        players: {
          name: 'players',
          type: 'Player[]',
          model: 'Player',
          relationType: 'hasMany',
          modelThrough: 'PlayerGroupPlayer',
          keyThrough: 'playerId',
          keyFrom: 'id',
          keyTo: 'playerGroupId'
        },
        overridePlayers: {
          name: 'overridePlayers',
          type: 'Player[]',
          model: 'Player',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'overrideGroupId'
        },
        screens: {
          name: 'screens',
          type: 'Screen[]',
          model: 'Screen',
          relationType: 'hasMany',
          modelThrough: 'PlayerGroupScreen',
          keyThrough: 'screenId',
          keyFrom: 'id',
          keyTo: 'playerGroupId'
        },
        kanvasUser: {
          name: 'kanvasUser',
          type: 'KanvasUser',
          model: 'KanvasUser',
          relationType: 'belongsTo',
                  keyFrom: 'kanvasUserId',
          keyTo: 'id'
        },
        parentContributor: {
          name: 'parentContributor',
          type: 'KanvasUser',
          model: 'KanvasUser',
          relationType: 'belongsTo',
                  keyFrom: 'parentContributorId',
          keyTo: 'id'
        },
        categoryRotation: {
          name: 'categoryRotation',
          type: 'CategoryRotation',
          model: 'CategoryRotation',
          relationType: 'belongsTo',
                  keyFrom: 'categoryRotationId',
          keyTo: 'id'
        },
        scheduleTimeframes: {
          name: 'scheduleTimeframes',
          type: 'ScheduleTimeframe[]',
          model: 'ScheduleTimeframe',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'playerGroupId'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/PlayerGroup.ts